import script from "./StatisticsCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticsCards.vue?vue&type=script&setup=true&lang=ts"

import "./StatisticsCards.vue?vue&type=style&index=0&id=ad2f1e2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad2f1e2e"]])

export default __exports__